var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 53,
    viewBox: "0 0 52 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_415_36141",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 52,
    height: 54
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.411 0.0078125H0.202637V53.0078H51.411V0.0078125Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_415_36141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.0098 51.3518H11.4043C10.131 51.3518 8.91002 50.8278 8.00962 49.8958C7.10932 48.9638 6.60352 47.7008 6.60352 46.3828",
    stroke: "#AE8FD6",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8067 4.97656H13.0046C11.3069 4.97656 9.67881 5.67456 8.47831 6.91656C7.27791 8.15856 6.60352 9.84456 6.60352 11.6016V46.3826C6.60352 45.0646 7.10932 43.8006 8.00962 42.8686C8.91002 41.9376 10.131 41.4136 11.4043 41.4136H43.4095C43.8339 41.4136 44.241 41.2396 44.541 40.9286C44.8412 40.6176 45.0098 40.1966 45.0098 39.7576V6.63257C45.0098 6.19357 44.8412 5.77158 44.541 5.46158C44.241 5.15058 43.8339 4.97656 43.4095 4.97656H38.6088",
    stroke: "#AE8FD6",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8096 51.3521V41.4141",
    stroke: "#AE8FD6",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6087 28.1641L32.2077 21.5391L25.8066 28.1641V4.97705C25.8066 4.09805 26.1438 3.25506 26.744 2.63406C27.3442 2.01306 28.1584 1.66406 29.0072 1.66406H35.4082C36.257 1.66406 37.0712 2.01306 37.6714 2.63406C38.2716 3.25506 38.6087 4.09805 38.6087 4.97705V28.1641Z",
    stroke: "#AE8FD6",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookHome);
export default __webpack_public_path__ + "static/media/Book-home.00f9d09e32f462c07bdb94b8d0ebcfd1.svg";
export { ForwardRef as ReactComponent };